import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const AddPrintPackageIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.215.33v1.912H3.583c-.921 0-1.672.75-1.672 1.672v8.503c0 .921.75 1.672 1.672 1.672h8.503c.922 0 1.672-.75 1.672-1.672V9.784h1.911v2.633A3.587 3.587 0 0 1 12.086 16H3.583A3.587 3.587 0 0 1 0 12.417V3.914A3.587 3.587 0 0 1 3.583.33h2.632ZM13.007 0v2.993H16v1.911h-2.993v2.993h-1.911V4.904H8.103V2.993h2.993V0h1.911Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

AddPrintPackageIcon.propTypes = propTypes;

export default AddPrintPackageIcon;
